import React, { useState, useEffect } from 'react';
import {
  BrowserRouter, Navigate, Route, Routes,
} from 'react-router-dom';
import { getCookie } from './helpers/cookies';
import Main from './components/Main/Main';
import Navbar from './components/Navbar/Navbar';
import BottomNav from './components/BottomNav/BottomNav';
import Login from './pages/login/login';
import Payments from './pages/payments/payments';
import InstallerPack from './pages/installerPack/installerPack';

import './App.css';

function App() {
  const [user, setUser] = useState(getCookie('user'));
  const [superUser, setSuperUser] = useState(!!getCookie('login_level'));

  useEffect(() => {
    setUser(getCookie('user'));
    setSuperUser(!!getCookie('login_level'));
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        {user && <Navbar />}
        <Routes>
          <Route
            exact
            path="/"
            element={user ? <Navigate to="/jobs" /> : <Navigate to="/login" />}
          />
          <Route exact path="/login" element={user ? <Main /> : <Login />} />
          <Route exact path="/jobs" element={<Main />} />
          <Route path="/jobs/:id/:lsui" element={<InstallerPack />} />
          {superUser && <Route exact path="/payments" element={<Payments />} />}
        </Routes>
        {superUser && <BottomNav />}
      </BrowserRouter>
    </div>
  );
}

export default App;
